export const currentUserState = function ({ currentUID, byUser }) {
  return { ...byUser[currentUID], currentUID };
};

export default currentUserState;
